import { HttpClient } from './httpClient';
import { env } from '../../../config/env';

export const apiClient = new HttpClient({
  baseURL: env.apiBaseUrl,
  timeout: 30000,
  retries: env.environment === 'production' ? 2 : 1,
});

export * from './types';
export * from './httpClient'; 